const FormDivider = () => {
  return (
    <div className="columns">
      <div className="column is-12">
        <div className="event-form-divider" />
      </div>
    </div>
  )
}

export default FormDivider
